import React from "react";
import Seo from "../../components/seo";
import { Link } from "gatsby";
import Carousel from "../../components/layout/Carousel";
import useIsInViewport from "../../hooks/useIsInViewport";
// import Tooltip from '../plugins/Tooltip';

/* START: images import */
import biocultus from "../../img/services/biocultus.svg";
import napraia from "../../img/services/logo-na-praia.svg";
import zpevnik from "../../img/services/zpevnik.svg";
import mouse_app from "../../img/services/mouse_app.svg";
import furnatura from "../../img/services/furnatura-prague.svg";
import spell from "../../img/services/spell.svg";
import kohinoor from "../../img/services/kohinoor.svg";
import project_royal_mail from "../../img/services/project_royal_mail.svg";
import project_mondelez from "../../img/services/project_mondelez.svg";
import experience_react from "../../img/services/react.svg";
import experience_angular from "../../img/services/angular.svg";
import experience_laravel from "../../img/services/laravel.svg";
import experience_gitlab from "../../img/services/gitlab.svg";
import experience_electron from "../../img/services/electron.svg";
import experience_gatsby from "../../img/services/gatsby.svg";
import experience_trello from "../../img/services/trello.svg";
import experience_android from "../../img/services/android.svg";
import experience_ios from "../../img/services/ios.svg";
import experience_nodejs from "../../img/services/nodejs.svg";
import experience_slack from "../../img/services/slack.svg";
import experience_mysql from "../../img/services/mysql.svg";
import experience_atlassian from "../../img/services/atlassian.svg";
import joalis_logo from "../../img/services/logo-joalis.png";
import mpm from "../../img/services/mpm.svg";
import smreflex from "../../img/services/smreflex.svg";
import firebase from "../../img/services/firebase.svg";
import aws from "../../img/services/aws.svg";
import nextjs from "../../img/services/nextjs.svg";
import swagger from "../../img/services/swagger.svg";
import postman from "../../img/services/postman.svg";
import docker from "../../img/services/docker.svg";
import figma from "../../img/services/figma-logo.svg";

/* END: images import */

const carouselItems = [
    { src: nextjs, alt: "Nextjs" },
    { src: experience_react, alt: "React Native" },
    { src: experience_angular, alt: "Angular" },
    { src: experience_nodejs, alt: "NodeJS" },
    { src: experience_laravel, alt: "Laravel" },
    { src: figma, alt: "Figma" },
    /*     { src: experience_gatsby, alt: "Gatsby" }, */
    // { src: experience_gulp, alt: "Gulp" },
    // { src: experience_cordova, alt: "Cordova" },
    { src: experience_ios, alt: "iOS" },
    /* { src: experience_atlassian, alt: "Atlassian" }, */
    { src: experience_android, alt: "Android" },
    { src: experience_electron, alt: "Electron" },
    { src: experience_gitlab, alt: "GitLab" },
    /* { src: experience_trello, alt: "Trello" }, */
    /* { src: experience_slack, alt: "Slack" }, */
    // { src: experience_docker, alt: "Docker" },
    { src: experience_mysql, alt: "MySQL" },
    // { src: jenkins, alt: "Jenkins" },
    { src: aws, alt: "AWS" },
    { src: firebase, alt: "Firebase" },
    { src: swagger, alt: "Swagger" },
    { src: postman, alt: "Postman" },
    { src: docker, alt: "Docker" },
    /* { src: sketch, alt: "Sketch" }, */
    // { src: aws, alt: "AWS" },
    // { src: protractor, alt: "Protractor" },
    // { src: mobx, alt: "Mob X" },
    //        {src:arduino, alt:"Arduino"},
    // { src: jasmine, alt: "Jasmine" },
    // { src: raspi, alt: "Raspberry Pi" }
];

const Intro = ({ indx, setObserverRef }) => (
    <article className="article" id="SSG" ref={setObserverRef} data-observer={indx}>
        <article className="text">
            <h2 className="line animate-1">Next.js</h2>
            <p className="animate-2">
                <a href="https://nextjs.org/" target="_blank" rel="noopener noreferrer">Next.js</a> nám pomáhá vytvářet vysoce výkonné webové aplikace a superrychlé webové stránky. Je proslulý tím, že usnadňuje lepší uživatelský zážitek a umožňuje rychlý
                vývoj produktu. Jeho schopnosti využívají velké firmy jako{" "}
                <a href="https://www.netflix.com" target="_blank" rel="noopener noreferrer">
                    Netflix
                </a>
                ,{" "}
                <a href="https://www.nike.com" target="_blank" rel="noopener noreferrer">
                    Nike
                </a>{" "}
                nebo{" "}
                <a href="https://www.uber.com" target="_blank" rel="noopener noreferrer">
                    Uber
                </a>
                , ale i nově vznikající startupy.
            </p>
        </article>
        <article>
            <h3 className="animate-3">Příklady Next.js projektů</h3>
            <div className="examples animate-4">
                <div>
                    <img className="animate-5" src={mpm} style={{ margin: "28px", height: "78px" }} alt="DrMouse" />
                    <h4 className="line project animate-6">Online katalog</h4>
                    <p className="animate-7">
                        <a href="https://nextjs.org/" target="_blank" rel="noopener noreferrer">Next.js</a> nám umožnil dostat to nejlepší z obou světů. Výkon předgenerovaných stránek bez nutnosti přegenerovávat celý web znovu a znovu. Část webu, která se
                        často nemění, je předgenerována, zatímco dynamický obsah zůstává vždy aktuální.
                    </p>
                    <a className="animate-8" href="https://www.mobilephonemuseum.com" target="_blank" rel="noopener noreferrer">
                        Navštivte web
                    </a>
                </div>
                <div>
                    <img className="animate-5" src={joalis_logo} style={{ margin: "40px", maxWidth: "150px", marginTop: "10px" }} alt="Joalis" />
                    <h4 className="line project animate-6">Technologická chuťovka</h4>
                    <p className="animate-7">
                        Plnotučná{" "}
                        <a href="https://www.shop8.cz/" target="_blank" rel="noopener noreferrer">
                            shop8
                        </a>{" "}
                        experience - Vyladěná administrace, obsáhlý GraphQL endpoint, S3, robustní pipeline, super rychlý web, front shop. Podpora více jazyků,
                        mnoho variant produktů, různých měn a řady platebních bran.
                    </p>
                    <a className="animate-8" href="https://www.joalis.cz/" target="_blank" rel="noopener noreferrer">
                        Navštivte web
                    </a>
                </div>
            </div>
        </article>
    </article>
);

const Eshops = ({ indx, setObserverRef }) => (
    <article className="article" id="eshop" ref={setObserverRef} data-observer={indx}>
        <article className="text">
            <h2 className="line animate-1">E-commerce platforma</h2>
            <p className="animate-2">
                Pro naše klienty stavíme e-commerce řešení na vlastní, osvědčené platformě, která je připravená k okamžitému nasazení a zároveň snadno přizpůsobitelná. Umožňuje rychlý start, stabilní provoz a úpravy na míru - od funkcí a integrací až po růst spolu s vaším byznysem.
            </p>
        </article>
        <h3 className="animate-3">Příklady</h3>
        <article className="examples animate-4">
            <div>
                <img className="animate-5" src={biocultus} style={{ margin: "85px", maxWidth: "300px" }} alt="MagnusArt" />
                <h4 className="line project animate-6">E-shop</h4>
                <p className="animate-7">
                    Vytvořili jsme moderní e-shop pro Biocultus, který nabízí špičkové finské kompostovací systémy. Web je postaven na vlastním systému Shop8 s frontendem v Next.js a je připraven obsluhovat různé evropské trhy - podporuje vícejazyčné prostředí, rozdílné jurisdikce a práci s různými měnami. Počet zapojených zemí se postupně rozšiřuje.
                </p>
                <a className="animate-8" href="https://biocultus.com" target="_blank" rel="noopener noreferrer">
                    Navštivte web
                </a>
            </div>
            <div>
                <img className="animate-5" src={furnatura} style={{ margin: "25px", width: "240px" }} alt="Furnatura" />
                <h4 className="line project animate-6">Klíč ke zdravé srsti psů</h4>
                <p className="animate-7">
                    Další realizace naší e-commerce platformy Shop8. Tentokrát stylový e-shop pro prémiovou českou značku Furnatura, zaměřenou na přírodní kosmetiku pro psy. Rychlý, víceměnový, vícejazyčný, s čistým a elegantním designem.
                </p>
                <a className="animate-8" href="https://www.furnatura.com/" target="_blank" rel="noopener noreferrer">
                    Zobrazit web
                </a>
            </div>
        </article>
    </article>
);

const CMSs = ({ indx, setObserverRef }) => (
    <article className="article" id="cms" ref={setObserverRef} data-observer={indx}>
        <div className="text">
            <h2 className="line animate-1">Vlastní CMS řešení</h2>
            <p className="animate-2">
                Náš vlastní modulární CMS dává klientům svobodu skládat stránky z obsahových bloků, aniž by utrpěla konzistence a čistý design. Je ideální pro projekty, kde je potřeba flexibilní správa obsahu, ale zároveň kontrola nad strukturou a vizuální podobou webu.
            </p>
        </div>
        <h3 className="animate-3">Například...</h3>
        <div className="examples animate-4">
            <div>
                <img className="animate-5" src={napraia} style={{ margin: "42px", width: "240px" }} alt="Na Praia" />
                <h4 className="line project animate-6">Flexibilní webová brožura</h4>
                <p className="animate-7">
                    Náš dlouhodobý klient chtěl mít možnost skládat stránky z modulárních typů obsahu se zachováním čistého a konzistentního designu. Náš vlastní CMS byl pro tento přístup ideálním řešením.
                </p>
                <a className="animate-8" href="https://www.napraia.com/" target="_blank" rel="noopener noreferrer">
                    Navštivte web
                </a>
            </div>
            <div>
                <img className="animate-5" src={spell} style={{ margin: "25px", maxWidth: "150px" }} alt="Biocultus" />
                <h4 className="line project animate-6">Spelldesk – Pokladní systém</h4>
                <p className="animate-7">
                    Dodali jsme řešení na míru pro kadeřnické studio, které pokrývá pokladní operace, prodej služeb i položek bistra a poskytuje přehledné výkazy denního provozu.
                </p>
                <a className="animate-8" href="mailto:info@code8.cz">
                    Dozvědět se více
                </a>
            </div>
        </div>
    </article>
);

const MobileApps = ({ indx, setObserverRef }) => (
    <article className="article" id="mobileApps" ref={setObserverRef} data-observer={indx}>
        <div className="text">
            <h2 className="line animate-1">Mobilní aplikace</h2>
            <p className="animate-2">
                Sdílení až 80 % kódu mezi Androidem a iOS vám ušetří spoustu nákladů dnes i při dalším vývoji v budoucnosti. Spoléháme na dvě hybridní technologie - React Native a
                NativeScript.
            </p>
        </div>
        <h3 className="animate-3">Příklady mobilních aplikací</h3>
        <div className="examples animate-4">
            <div>
                <img className="animate-5" src={mouse_app} style={{ margin: "40px", width: "85px" }} alt="Dr Mouse App" />
                <h4 className="line project animate-6">Veterinář s přehledem</h4>
                <p className="animate-7">Dr. Mouse je mobilní aplikace pro Android i iOS. Poskytne vám přehled veterinárních ordinací v celé České republice. A to i offline.</p>
                <a className="animate-8" href="https://www.drmouse.cz/aplikace" target="_blank" rel="noopener noreferrer">
                    Navštivte web
                </a>
            </div>
            <div>
                <img className="animate-5" src={smreflex} style={{ margin: "45px", height: "70px" }} alt="Debrett’s wedding planner" />
                <h4 className="line project animate-6">SM Reflex</h4>
                <p className="animate-7">
                    Program společnosti Zentiva je zaměřen na pacienty s onemocněním roztroušené sklerózy. Smyslem aplikace je pomoci pacientovi zvládnout jeho onemocnění a
                    poskytovat přínosné informace, které pomohou zlepšit kvalitu jeho života.
                </p>
                <a className="animate-8" href="https://smreflex.sk/" target="_blank" rel="noopener noreferrer">
                    Navštivte web
                </a>
            </div>
        </div>
    </article>
);

const BeSpoke = ({ indx, setObserverRef }) => (
    <article className="article" id="bespoke" ref={setObserverRef} data-observer={indx}>
        <div className="text">
            <h2 className="line animate-1">API, backendové systémy &amp; DevOps</h2>
            <p className="animate-2">
                Programujeme v NodeJS a PHP. Obvykle používáme relační databáze a REST API, provádíme úkony typu systémový audit, optimalizace, migrace obsahu apod. Máme značnou
                zkušenost v oblasti DevOps, kontinuální integrace, testování a automatizovaného deploymentu.
            </p>
        </div>
        <h3 className="animate-3">Příklady řešení</h3>
        <div className="examples animate-4">
            <div>
                <img className="animate-5" src={project_royal_mail} style={{ margin: "40px", width: "150px" }} alt="Royal Mail PAF" />
                <h4 className="line project animate-6">Royal Mail PAF</h4>
                <p className="animate-7">
                    S našimi dlouholetými partnery z{" "}
                    <a href="http://www.dataadvance.co.uk" target="_blank" rel="noopener noreferrer">
                        Data advance
                    </a>{" "}
                    máme za sebou několik úspěšných projektů, například Royal Mail's PAF Licensing Centre.
                </p>
                <a className="animate-8" href="http://www.poweredbypaf.com/licensing-centre/" target="_blank" rel="noopener noreferrer">
                    Navštivte web
                </a>
            </div>
            <div>
                <img className="animate-5" src={project_mondelez} style={{ margin: "65px", maxWidth: "300px" }} alt="Mondelez" />
                <h4 className="line project animate-6">Interaktivní mapa</h4>
                <p className="animate-7">
                    Integrací API jednotlivých sociálních sítí a Google Maps jsme vytvořili nástroj na podrobný přehled značek a jejich aktivity na sociálních sítích.
                </p>
                <a className="animate-8" href="mailto:hello@code8.cz">
                    Vyžádejte si ukázku kódu
                </a>
            </div>
        </div>
    </article>
);

const Experience = ({ indx, setObserverRef }) => (
    <article className="article" id="experience" ref={setObserverRef} data-observer={indx}>
        <div className="text">
            <h2 className="line animate-1">A dál?</h2>
            <p className="animate-2">Máme dlouholeté zkušenosti s následujícími technologiemi. </p>
        </div>
        <div id="experienced" className="animate-3">
            <Carousel items={carouselItems} />
        </div>
        <div className="clear"></div>
        <div className="text animate-4" style={{ position: "relative", zIndex: 500 }}>
            <br />
            <p>
                Podívejte se, <Link to="/cz/projekty/">co pro vás můžeme udělat</Link>
            </p>
        </div>
    </article>
);

const sections = [Intro, Eshops, CMSs, MobileApps, BeSpoke, Experience];

const Services = () => {
    const { setRef } = useIsInViewport();
    return (
        <>
            <Seo title="Co umíme" lang="cs" />
            <div>
                {sections.map((Component, index) => (
                    <Component key={index} indx={index} setObserverRef={setRef} />
                ))}
            </div>
            <div className="clear"></div>
        </>
    );
};
export default Services;
